import { createSlice } from "@reduxjs/toolkit"

const cartInitialState = {
    modalIsOpen: false,
    itemToRemoveFromCart: {},
    activePatientDetailDto: {},
    cartDtoList: [] as any[],
    cityUuid: '',
    totalAmount: 0,
}
const cartSlice = createSlice({
    name: 'cartDataReducer',
    initialState: cartInitialState,
    reducers: {
        updateCartData: (state, action) => {
            state.modalIsOpen = action.payload.modalIsOpen
            state.activePatientDetailDto = action.payload.activePatientDetailDto
            state.cartDtoList = action.payload.cartDtoList
            state.cityUuid = action.payload.cityUuid
            state.totalAmount = action.payload.totalAmount
        },
        askUserToRemoveItems: (state, action) => {
            state.itemToRemoveFromCart = action.payload.itemToRemoveFromCart
        },
        resetCartData: () => {
            return cartInitialState
        }
    }
})
export const { updateCartData, askUserToRemoveItems, resetCartData } = cartSlice.actions
export default cartSlice.reducer 